export default __webpack_public_path__ + "static/media/treatment_no_select.36ccb5b0.png";